<nav>
  <div class="nav-meta">
    <div auto="left-nav-strat-name" class="title">{{strategyName}}</div>
    <div class="subtitle">
      <div class="plan-date">{{ targetStartDate | date: 'M/d/yy'}}</div>
      <span *ngIf="targetStartDate || targetEndDate"> - </span>
      <div class="plan-date">{{ targetEndDate | date: 'M/d/yy'}}</div>
    </div>
  </div>
  <ul auto="left-nav-li" class="styleless plan-tree">
    <li *ngFor="let domain of domains">
      <div class="domain title nav-item">
        <span auto="domain-title-txt">{{domain.domain_name}}</span>
        <img auto="progress-img" appProgressImg [progress]="domain.percentComplete" [alt]="domain.percentComplete">
      </div>
      <ul class="styleless steps">
        <li *ngFor="let step of domain.steps"
            class="pointer"
            [ngClass]="{selected: isSelected(step)}"
            (click)="onStepClick(step)">
          <div class="nav-item">
            <img *ngIf="step.isCompletable; else other"
                 appProgressImg [progress]="step.complete ? 100 : 0" [alt]="step.complete ? 100 : 0">
            <ng-template #other>
              <img class="guide-step-image" src="assets/images/page.svg" [alt]="step.step_name">
            </ng-template>
            <span auto="step-title-txt" class="step-title">{{step.step_name}}</span>
          </div>
        </li>
      </ul>
    </li>
    <li>
      <ul class="styleless steps steps-no-domain">
        <li class="pointer"
            [ngClass]="{selected: isSelected(outputsStep)}"
            (click)="onStepClick(outputsStep)">
          <div class="nav-item">
            <img src="assets/images/outputs.svg" [alt]="outputsStep.step_name">
            <span auto="output-step-txt" class="step-title">{{outputsStep.step_name}}</span>
          </div>
        </li>
      </ul>
    </li>
  </ul>
</nav>
